export const SYNC_CTC_INFORMATION_OPEN_MODAL = "SYNC_CTC_INFORMATION_OPEN_MODAL";
export const SYNC_CTC_INFORMATION_REQUEST = "SYNC_CTC_INFORMATION_REQUEST";
export const SYNC_CTC_INFORMATION_RESULT = "SYNC_CTC_INFORMATION_RESULT";